export default __webpack_public_path__ + "static/media/pause.e90c5bd7.svg";